import sectionIntersection from '@/library/section-intersection'

export default {
  abstract: true,
  props: [ 'section' ],
  async mounted () {
    await this.$nextTick()
    sectionIntersection.observe(this.$el)
    sectionIntersection.on(this.$el, () => {
      this.$emit('intersected', this.section.id)
    })
  },
  beforeDestroy () {
    sectionIntersection.unobserve(this.$el)
  },
  render (h) {
    let component = this.$props.section.getComponent()

    return h(component, {
      class: [ 'content-section' ],
      attrs: {
        'data-id': this.$props.section.id
      },
      props: {
        item: this.$props.section
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/library/section-resolver.js